import { render, staticRenderFns } from "./mail-config-form.vue?vue&type=template&id=3aa10e08&scoped=true&"
import script from "./mail-config-form.vue?vue&type=script&lang=js&"
export * from "./mail-config-form.vue?vue&type=script&lang=js&"
import style0 from "./mail-config-form.vue?vue&type=style&index=0&id=3aa10e08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa10e08",
  null
  
)

export default component.exports